import React, { useEffect, useState } from "react";
import { LandingNavbar } from "../components/landing/LandingNavbar";
import { LandingPageFooter } from "../components/landing/LandingPageFooter";
import "../components/landing/landing.css";
import config from "../config";

export default function PublicTosPage() {
  const [theme, setTheme] = useState("light");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${config.API_BASE_URL}/api/tos/content`)
      .then(res => res.json())
      .then(data => {
        setContent(data.content || "Terms of Service content not available.");
      })
      .catch(err => {
        console.error("Failed to fetch ToS data:", err);
        setContent("Terms of Service content not available.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className={`hs-landing ${theme === "light" ? "lp-light-theme" : ""}`}>
      <LandingNavbar theme={theme} toggleTheme={toggleTheme} />
      
      <div className="lp-py-28 lp-px-6 lp-min-h-screen">
        <div className="lp-max-3xl lp-mx-auto lp-glass-card lp-r-3xl lp-p-8 md-p-16">
          <h1 className="lp-text-dark lp-text-4xl lp-mb-8" style={{ fontFamily: "'Fraunces', serif" }}>Terms of Service</h1>
          
          <div className="lp-text-muted lp-page-content" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            )}
          </div>
        </div>
      </div>

      <LandingPageFooter />
    </div>
  );
}
